module.exports = __webpack_public_path__ + "img/75_11.ca536d03.png";